/**
 * Configurações específicas para o cliente "Digitus"
 */
const settings: ClientSettings = {
  name: "Digitus",
  in100authority: "Digitus",
  downloadTermText: "Digitus",
  theme: {
    token: {
      colorPrimary: "#274359",
    },
  },
  assets: {
    logo: "/logo-digitus.png",
    favicon: "/favicon-digitus.png",
    card: "",
    refinCard: "",
    consignedCard: "",
    bankLogo: "",
    bank_name: "bmp",
  },
  cardExclusiveTheme: {
    name: "Amigoz",
    theme: {
      token: {
        colorPrimary: "#274359",
      },
    },
    assets: {
      logo: "",
      favicon: "",
    },
  },
};

export default settings;
